import { render } from "./FTSWeeklyTable.vue?vue&type=template&id=60ab05ea&scoped=true&ts=true"
import script from "./FTSWeeklyTable.vue?vue&type=script&lang=ts"
export * from "./FTSWeeklyTable.vue?vue&type=script&lang=ts"

import "./FTSWeeklyTable.vue?vue&type=style&index=0&id=60ab05ea&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ab05ea"]])

export default __exports__